<ion-content class="modal-form">
  <ion-header  collapse="fade" [translucent]="false" class="ion-no-border">
    <ion-toolbar>
      <div class="header-layout">

        <div class="header-layout_button">
          <ion-icon
            *ngIf="showBackButton && !nativeBack"
            (click)="back.emit()"
            src="assets/back_arrow.svg"
            class="header-layout_button">
          </ion-icon>

          <ion-back-button class="back-btn"
            *ngIf="showBackButton && nativeBack"
            text=""
            icon="assets/back_arrow.svg"
            class=""
            [defaultHref]="defaultLink">
          </ion-back-button>
        </div>

        <ion-icon 
            expand="block"
            class="header-layout_logo"
            src="assets/Vessel_logo.svg"
            alt="logo">
        </ion-icon>

        <div class="header-layout_button"></div>
      </div>
    </ion-toolbar>
  </ion-header>
  <div class="sub-page-layout">
    <ng-content></ng-content>
  </div>
</ion-content>